module.exports = __webpack_public_path__ + "static/media/gold.304debf6.png";